import React from 'react';
import Table from 'components/shared/table';

const getSort = (column, sort) =>
  sort.column === column ? sort.direction : undefined;

const TemplateHeader = ({ sort, onSort, tableHeaders }) => (
  <Table.Header>
    {tableHeaders.map(({ name, label, size, sortType }) => (
      <Table.HeaderCell
        key={name}
        className="Table-cell--clickable Table-cell--sortable"
        onClick={e => onSort({ column: name, sortType }, e)}
        sort={getSort(name, sort)}
        size={size}
      >
        {label}
      </Table.HeaderCell>
    ))}
  </Table.Header>
);

export default TemplateHeader;
